import { render, staticRenderFns } from "./MetricsTable.vue?vue&type=template&id=22cf5860&"
import script from "./MetricsTable.vue?vue&type=script&lang=js&"
export * from "./MetricsTable.vue?vue&type=script&lang=js&"
import style0 from "./MetricsTable.vue?vue&type=style&index=0&id=22cf5860&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports